"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Verification = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Verification = () => {
    // const onHumanVerification = async () => {
    //   if (await isVerified(props.fid)) {
    //     // setVerified(true)
    //     console.log("verified")
    //   }
    //   else {
    //     // setVerified(false)
    //     // setShowModal(true)
    //     console.log("not verified")
    //   }
    // }
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("a", { href: "https://farcaster-sandy.vercel.app/", children: "For Verification visit website" }) }));
};
exports.Verification = Verification;
exports.default = exports.Verification;
